<div>
  <div class="title">
    <img src="{{licenceService.getKey('category-luckera-icon')}}"/>
    <div i18n>
      Categories
    </div>
  </div>
  <div class="cards">
    <div (click)="openCategory(item)" *ngFor="let item of categories ">
      <div class="card">
        <img src="{{item.thumbnail?.url}}" alt="{{item.name}}" />
      </div>
        <div class="name" [innerHTML]="item.displayName | safeHtml"></div>
    </div>
  </div>
</div>
